export enum Language {
  ENGLISH = "en",
  GERMAN = "de",
}

export enum Locales {
  DE = "de-DE",
  EN = "en-US",
}
